import React from "react";

function ErrorCancelledLink() {
  return (
    <div className="uk-height-1-1 uk-flex uk-flex-center uk-flex-middle uk-flex-column uk-text-center">

      <h1 className="uk-margin-small-bottom">Link no longer active</h1>

      <p className="uk-margin-small-top" style={{ maxWidth: '450px' }}>
        This payment link is no longer active because the request was cancelled.
      </p>

      <p className="uk-margin-small-top" style={{ maxWidth: '450px' }}>
        If you still need to make a payment, please request a new link from the sender.
      </p>

    </div>
  )
}

export default ErrorCancelledLink
